module.exports = __webpack_public_path__ + "assets/img/QaKkPnoKQkBK7pdG.12842a0d.jpeg";